var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useRef } from "react";
import styled from "styled-components";
import useScreenSize from "../../hooks/useScreenSize";
export var MobileOverlayContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: ", ";\n  z-index: ", ";\n  transition: 0.25s all ease-out;\n  display: flex;\n\n  backdrop-filter: blur(40px);\n  /**\n   * Firefox desktop come with default flag to have backdrop-filter disabled\n   * Firefox Android also currently has bug where backdrop-filter is not being applied\n   * More info: https://bugzilla.mozilla.org/show_bug.cgi?id=1178765\n   **/\n  @-moz-document url-prefix() {\n    background-color: rgba(0, 0, 0, 0.9);\n  }\n\n  ", "\n"], ["\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: ", ";\n  z-index: ", ";\n  transition: 0.25s all ease-out;\n  display: flex;\n\n  backdrop-filter: blur(40px);\n  /**\n   * Firefox desktop come with default flag to have backdrop-filter disabled\n   * Firefox Android also currently has bug where backdrop-filter is not being applied\n   * More info: https://bugzilla.mozilla.org/show_bug.cgi?id=1178765\n   **/\n  @-moz-document url-prefix() {\n    background-color: rgba(0, 0, 0, 0.9);\n  }\n\n  ", "\n"])), function (props) { return (props.height ? props.height + "px" : "100vh"); }, function (props) { return (props.isMenuOpen ? 50 : -1); }, function (props) {
    return props.isMenuOpen
        ? "\n    opacity: 1;\n  "
        : "\n    opacity: 0;\n    visibility: hidden;\n  ";
});
var MobileOverlayMenu = function (_a) {
    var isMenuOpen = _a.isMenuOpen, children = _a.children, onClick = _a.onClick, mountRoot = _a.mountRoot, boundingDivProps = _a.boundingDivProps, _b = _a.overflowOnOpen, overflowOnOpen = _b === void 0 ? true : _b, props = __rest(_a, ["isMenuOpen", "children", "onClick", "mountRoot", "boundingDivProps", "overflowOnOpen"]);
    var containerRef = useRef(null);
    var height = useScreenSize().height;
    useEffect(function () {
        if (!containerRef.current || !mountRoot) {
            return;
        }
        document.querySelector(mountRoot).appendChild(containerRef.current);
    }, [containerRef, mountRoot]);
    useEffect(function () {
        if (isMenuOpen && overflowOnOpen) {
            document.querySelector("body").style.overflow = "hidden";
            return;
        }
        document.querySelector("body").style.removeProperty("overflow");
    }, [isMenuOpen, overflowOnOpen]);
    return (_jsx(MobileOverlayContainer, __assign({ isMenuOpen: isMenuOpen, height: height, onClick: function (event) {
            onClick && onClick(event);
        }, ref: containerRef }, props, { children: React.Children.map(children, function (child) { return (_jsx("div", __assign({ onClick: function (e) { return e.stopPropagation(); } }, boundingDivProps, { children: child }), void 0)); }) }), void 0));
};
export default MobileOverlayMenu;
var templateObject_1;
//# sourceMappingURL=MobileOverlayMenu.js.map